export default __webpack_public_path__ + "static/media/nikunjo.950900e6.png";